(function () {
  "use strict";

  function isGerman() {
    return (document.documentElement.lang || "").toLowerCase().indexOf("de") === 0;
  }

  function message(status, de, en) {
    if (!status) {
      var shared = null;
      try { shared = JSON.parse(localStorage.getItem("wynch_article_club_confirmed_ui_v1") || "null"); } catch (_) {}
      var state = shared && (shared.state || (shared.confirmedAt ? "confirmed" : "entry")) || "entry";
      document.querySelectorAll("[data-wynch-cart-club-form]").forEach(function (form) {
        form.dataset.clubUiState = state;
        var button = form.querySelector('[type="submit"]');
        if (!button.dataset.originalLabel) button.dataset.originalLabel = button.textContent;
        button.textContent = state === "claimed" ? (isGerman() ? "Warenkorb öffnen" : "Open my cart") : state === "confirmed" ? (isGerman() ? "Meine Cava sichern" : "Claim My Cava") : state === "pending" ? (isGerman() ? "Prüfe deine E-Mail" : "Check your email") : button.dataset.originalLabel;
        form.elements.email.hidden = state === "confirmed" || state === "claimed";
        form.elements.email.required = !form.elements.email.hidden;
        message(form.parentNode.querySelector("[data-wynch-cart-club-status]"), state === "claimed" ? "Deine Geschenke sind im Warenkorb." : state === "confirmed" ? "Deine Willkommensgeschenke sind bereit." : state === "pending" ? "Wir warten auf deine E-Mail-Bestätigung." : "", state === "claimed" ? "Your gifts are in your cart." : state === "confirmed" ? "Your welcome gifts are ready." : state === "pending" ? "We’re waiting for your email confirmation." : "");
      });
      return;
    }
    if (status) status.textContent = isGerman() ? de : en;
  }

  document.addEventListener("submit", function (event) {
    var form = event.target.closest && event.target.closest("[data-wynch-cart-club-form]");
    if (!form) return;
    event.preventDefault();
    if (form.dataset.clubUiState && form.dataset.clubUiState !== "entry" && window.WynchClubFlowV1) {
      if (form.dataset.clubUiState === "pending") window.WynchClubFlowV1.renderState(null, true, true);
      else window.WynchClubFlowV1.resend().catch(function () { message(form.parentNode.querySelector("[data-wynch-cart-club-status]"), "Bitte versuche es erneut.", "Please try again."); });
      return;
    }
    if (!form.reportValidity()) return;

    var button = form.querySelector('button[type="submit"]');
    var status = form.parentNode.querySelector("[data-wynch-cart-club-status]");
    var email = String(form.elements.email.value || "").trim();
    if (!email || button.disabled) return;
    if (!window.WynchClubFlowV1 || typeof window.WynchClubFlowV1.register !== "function") {
      message(status, "Bitte versuche es gleich noch einmal.", "Please try again in a moment.");
      return;
    }

    button.disabled = true;
    message(status, "Bestätigungs-E-Mail wird angefordert …", "Requesting your confirmation email …");
    window.WynchClubFlowV1.register({
      source: "cart_register",
      channelId: "cart_register",
      email: email,
      locale: isGerman() ? "de" : "en",
      returnPath: window.location.pathname + window.location.search
    }).then(function (result) {
      if (result && result.state !== "confirmed") {
        message(status, "Prüfe deine E-Mail und bestätige die Anmeldung.", "Check your email and confirm your subscription.");
        var pending = document.querySelector("[data-wynch-club-pending]");
        if (pending && !pending.hidden) {
          message(pending.querySelector("[data-wynch-club-pending-title]"), "Prüfe deine E-Mail", "Check your email");
          message(pending.querySelector("[data-wynch-club-pending-body]"), "Öffne den Bestätigungslink aus dem Postfach. Deine Startgeschenke sind danach bereit.", "Open the confirmation link in your inbox. Your welcome gifts will be ready after that.");
        }
      }
    }).catch(function (error) {
      var code = error && error.payload && error.payload.error;
      if (code === "CAVA_ENROLLMENT_ALREADY_CONFIRMED_V1") {
        message(status, "Diese E-Mail ist bereits bestätigt. Öffne den persönlichen Link aus deiner Bestätigungs-E-Mail erneut, um deine Geschenke diesem Browser zuzuordnen.", "This email is already confirmed. Reopen the personal link in your confirmation email to connect your gifts to this browser.");
      } else if (code === "DOI_SUBSCRIBER_SUPPRESSED_V1") {
        message(status, "Diese Adresse kann keine Bestätigungs-E-Mail empfangen. Bitte verwende eine andere E-Mail.", "This address cannot receive a confirmation email. Please use another email.");
      } else {
        message(status, "Die Anfrage konnte nicht gesendet werden. Bitte versuche es erneut.", "We couldn't send the request. Please try again.");
      }
    }).finally(function () {
      button.disabled = false;
    });
  });
  window.addEventListener("wynch:club-enrollment-registered", function (event) { if (event.detail && event.detail.uiOnly) message(); });
  window.addEventListener("storage", function (event) { if (event.key === "wynch_article_club_confirmed_ui_v1") message(); });
  document.addEventListener("input", function (event) {
    var form = event.target.closest && event.target.closest("[data-wynch-cart-club-form]");
    if (form && form.dataset.clubUiState === "pending" && window.WynchClubFlowV1) window.WynchClubFlowV1.renderState({ state: "entry" }, true, false);
  });
  new MutationObserver(function (records) {
    if (records.some(function (record) { return Array.from(record.addedNodes).some(function (node) { return node.nodeType === 1 && (node.matches("[data-wynch-cart-club-form]") || node.querySelector("[data-wynch-cart-club-form]")); }); })) message();
  }).observe(document.documentElement, { childList: true, subtree: true });
  message();
}());
